// material-ui
import { Box } from '@mui/material';

// types
import DefaultPageStructure from 'layout/MainLayout/Structures/DefaultPageStructure';
import { decodeToken } from 'utils/functions/jwt-token';
import Menus from './Menus/index';
import menuItems from 'menu-items/index';

// ==============================|| MAIN LAYOUT ||============================== //

const MainLayout = () => {
  const userData = decodeToken();
  const role = userData?.user_type;
  // const navigation = role === 'S' ? { items: [supplier] } : { items: [retailer] };
  const navigation = menuItems;

  return userData ? (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100vw' }} id="main-layout">
      <Menus />
      <DefaultPageStructure navigation={navigation} />
    </Box>
  ) : (
    <Box sx={{ display: 'flex', width: '100%', maxWidth: '100vw' }} id="main-layout">
      <Menus />
      <DefaultPageStructure navigation={navigation} />
    </Box>
  );
};

export default MainLayout;
